<template>
    <section>
        <sui-segment basic>
            <sui-button basic icon="reply" floated="left" @click="$router.push({ name: recordName + 'List' })">Regresar</sui-button>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="edit"/>
                <sui-header-content>Detalle de {{ complaintTypeStr || 'consulta' }}</sui-header-content>
            </h2>
            <br><br>
        </sui-segment>
        <sui-grid>
            <sui-grid-row>
                <sui-grid-column :width="13">
                    <sui-segment>
                        <sui-form>
                            <sui-header dividing>Registro de {{ complaintTypeStr || 'Consulta' }}</sui-header>
                            <sui-form-fields fields="two">
                                <sui-form-field :error="!record.entityName">
                                    <label>Denominación o razón social</label>
                                    <sui-input
                                        v-if="record.editing && !record.id"
                                        type="text"
                                        v-model="record.entityName"
                                        readonly
                                    />
                                    <span v-else>{{ record.entityName }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.sector">
                                    <label>Sector</label>
                                    <input
                                        v-if="record.editing && !record.id"
                                        type="text"
                                        v-model="record.sector"
                                        readonly
                                    />
                                    <span v-else>{{ record.sector }}</span>
                                </sui-form-field>
                            </sui-form-fields>

                            <sui-form-field :error="!record.clientId">
                                    <label>Cliente</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        search
                                        v-model="record.clientId"
                                        :options="clientsOptions"
                                    />
                                    <span v-else>{{ clientStr }}</span>
                                </sui-form-field>
                            <sui-form-fields fields="four">
                                <sui-form-field v-if="record.folio">
                                    <label>Número de folio</label>
                                    <span v-if="record.id">{{ record.folio }}</span>
                                    <span v-else>El folio será asignado automáticamente al crear</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.complaintType">
                                    <label>Tipo de registro</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.complaintType"
                                        :options="reuneRecordOptions"
                                        @input="loadOperations"
                                    />
                                    <span v-else>{{ complaintTypeStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.statusId">
                                    <label>Estatus</label>
                                    <sui-dropdown
                                        v-if="record.editing && canEditAfterReport"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.statusId"
                                        :options="statusOptions"
                                    />
                                    <span v-else>{{ statusStr }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.complaintType !== ReuneRecordType.CONSULTA">
                                    <label>Número de folio CONDUSEF</label>
                                    <sui-input
                                        v-if="record.editing && !record.id"
                                        type="text"
                                        v-model="record.folioCondusef"
                                    />
                                    <span v-else>{{ record.folioCondusef }}</span>
                                </sui-form-field>
                                <!-- <sui-form-field>
                                    <label>Número de {{ complaintTypeStr || 'Consulta'  }}</label>
                                    <span>1</span>
                                </sui-form-field> -->
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field :error="!record.dateComplaint">
                                    <label>Fecha de recepción</label>
                                    <v-date-picker
                                        v-if="record.editing && !record.reported"
                                        v-model="record.dateComplaint"
                                        :masks="masks"
                                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                        @input="setTrimester"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateReceptionStr }}</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Trimestre a informar</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.trimesterReported"
                                        :options="trimesterOptions"
                                    />
                                    <strong v-else>{{ trimesterReportedStr }}</strong>
                                </sui-form-field>
                                <sui-form-field :error="!record.receivingMediumId">
                                    <label>Medio de recepción</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.receivingMediumId"
                                        :options="receivingMediumOptions"
                                        @input="record.sigeSystem = record.receivingMediumId === 6"
                                    />
                                    <span v-else>{{ receptionMediumStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field :error="record.status === 2 && !record.dateAttended">
                                    <label>Fecha de atención</label>
                                    <v-date-picker
                                        v-if="record.editing && canEditAfterReport"
                                        v-model="record.dateAttended"
                                        :masks="masks"
                                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateAttendedStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="record.status === 2 && !record.attentionLevelId">
                                    <label>Nivel de atención o contacto</label>
                                    <sui-dropdown
                                        v-if="record.editing && canEditAfterReport"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.attentionLevelId"
                                        :options="attentionLevelOptions"
                                    />
                                    <span v-else>{{ attentionLevelStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field :error="!record.identityTheft">
                                    <label>Posible robo de identidad (PORI)</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.identityTheft"
                                        :options="identityTheftOptions"
                                    />
                                    <span v-else>{{ record.identityTheft }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.complaintType !== ReuneRecordType.CONSULTA" :error="!record.taxRegimeId">
                                    <label>Tipo de persona</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.taxRegimeId"
                                        :options="taxRegimeOptions"
                                    />
                                    <span v-else>{{ taxRegimeStr }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.taxRegimeId == TaxRegime.PERSONA_FISICA && record.complaintType !== ReuneRecordType.CONSULTA" :error="!record.age">
                                    <label>Edad</label>
                                    <sui-input
                                        v-if="record.editing && !record.reported"
                                        type="number"
                                        v-model="record.age"
                                    />
                                    <span v-else>{{ record.age }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.taxRegimeId == TaxRegime.PERSONA_FISICA && record.complaintType !== ReuneRecordType.CONSULTA" :error="!record.gender">
                                    <label>Género</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.gender"
                                        :options="genderOptions"
                                    />
                                    <span v-else>{{ genderStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field :error="!record.stateId">
                                    <label>Entidad federativa</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        search
                                        v-model="record.stateId"
                                        :options="stateOptions"
                                        @input="loadLocations"
                                    />
                                    <span v-else>{{ stateStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.municipalityId">
                                    <label>Municipio</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        search
                                        clearable
                                        v-model="record.municipalityId"
                                        :options="locationOptions"
                                        @input="loadColonies"
                                    />
                                    <span v-else>{{ municipalityStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.postalCode">
                                    <label>Código postal</label>
                                    <input
                                        v-if="record.editing && !record.reported"
                                        type="number"
                                        v-model="record.postalCode"
                                        @blur="loadColonies"
                                    />
                                    <span v-else>{{ record.postalCode }}</span>
                                </sui-form-field>
                                <!-- <sui-form-field>
                                    <label>Localidad</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.locality"
                                    />
                                    <span v-else>{{ record.locality }}</span>
                                </sui-form-field> -->
                                <sui-form-field :error="!record.colonyId">
                                    <label>Colonia</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.colonyId"
                                        :options="colonyOptions"
                                    />
                                    <span v-else>{{ colonyStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field v-if="record.complaintType === ReuneRecordType.RECLAMACION">
                                    <label>Sentido de la resolución</label>
                                    <sui-dropdown
                                        v-if="record.editing && canEditAfterReport"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.resolutionId"
                                        :options="resolutionOptions"
                                    />
                                    <span v-else>{{ resolutionStr }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.complaintType !== ReuneRecordType.CONSULTA">
                                    <label>Fecha de resolución</label>
                                    <v-date-picker
                                        v-if="record.editing && canEditAfterReport"
                                        v-model="record.dateResolved"
                                        :masks="masks"
                                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateResolvedStr }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.complaintType !== ReuneRecordType.CONSULTA">
                                    <label>Fecha de notificación</label>
                                    <v-date-picker
                                        v-if="record.editing && canEditAfterReport"
                                        v-model="record.dateNotificated"
                                        :masks="masks"
                                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                </v-date-picker>
                                <span v-else>{{ dateNotificatedStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four" v-if="record.complaintType !== ReuneRecordType.CONSULTA">
                                <sui-form-field>
                                    <label>Monetario</label>
                                    <sui-checkbox
                                        toggle
                                        v-if="record.editing && !record.reported"
                                        v-model="record.monetary"
                                    />
                                    <span v-else>{{ monetaryStr }}</span>
                                </sui-form-field>
                                <sui-form-field v-if="record.complaintType === ReuneRecordType.ACLARACION">
                                    <label>Operación en el extranjero</label>
                                    <sui-checkbox
                                        toggle
                                        v-if="record.editing && !record.reported"
                                        v-model="record.foreignTransaction"
                                    />
                                    <span v-else>{{ foreignTransactionStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four" v-if="record.complaintType !== ReuneRecordType.CONSULTA">
                                <sui-form-field>
                                    <label>Monto reclamado o requerido</label>
                                    <sui-input
                                        v-if="record.editing && !record.reported"
                                        type="number"
                                        placeholder="0"
                                        v-model="record.amountDisputed"
                                    />
                                    <span v-else>${{ record.amountDisputed || 0 }}</span>
                                </sui-form-field>
                                <sui-form-field>
                                    <label>Monto aprobado</label>
                                    <sui-input
                                        v-if="record.editing && canEditAfterReport"
                                        type="number"
                                        placeholder="0"
                                        v-model="record.amountApproved"
                                    />
                                    <span v-else>${{ record.amountApproved || 0 }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.dateDeposited">
                                    <label>Fecha de depósito</label>
                                    <v-date-picker
                                        v-if="record.editing && canEditAfterReport"
                                        v-model="record.dateDeposited"
                                        :masks="masks"
                                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                    >
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <input
                                            class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                        />
                                    </template>
                                    </v-date-picker>
                                <span v-else>{{ dateDepositedStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-fields fields="four">
                                <sui-form-field :error="!record.operationId">
                                    <label>Tipo de operación</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.operationId"
                                        :options="operationOptions"
                                        @input="loadProducts"
                                    />
                                    <span v-else>{{ operationTypeStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.productId">
                                    <label>Producto</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.productId"
                                        :options="productOptions"
                                        @input="loadSubproducts"
                                    />
                                    <span v-else>{{ productTypeStr }}</span>
                                </sui-form-field>
                                <sui-form-field :error="!record.subproductId">
                                    <label>Subproducto</label>
                                    <sui-dropdown
                                        v-if="record.editing && !record.reported"
                                        placeholder="Seleccione"
                                        selection
                                        v-model="record.subproductId"
                                        :options="subproductOptions"
                                        @input="loadReasons"
                                    />
                                    <span v-else>{{ subproductTypeStr }}</span>
                                </sui-form-field>
                            </sui-form-fields>
                            <sui-form-field :error="!record.reasonId">
                                <label>Causa o motivo</label>
                                <sui-dropdown
                                    v-if="record.editing && !record.reported"
                                    placeholder="Seleccione"
                                    selection
                                    v-model="record.reasonId"
                                    :options="reasonOptions"
                                />
                                <span v-else>{{ reasonStr }}</span>
                            </sui-form-field>
                        </sui-form>
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column :width="3" textAlign="center">
                    <div class="ui warning message" v-if="!record.active">
                        <i class="info circle icon"></i> <strong>Registro inhabilitado</strong>
                    </div>
                    <div class="ui positive message" v-if="record.reported && !record.failed">
                        <i class="check circle icon"></i> <strong>Registro reportado</strong>
                    </div>
                    <div class="ui negative message" v-if="record.failed">
                        <i class="times circle icon"></i> <strong>Registro rechazado</strong>
                    </div>
                    <div class="ui info message" v-if="record.id">
                        <i class="clock outline icon"></i>
                        <strong>Último intento de reporte:</strong><br>
                        <span>{{ reportedAtStr }}</span>
                    </div>
                    <div class="ui vertical fluid menu">
                        <div class="header header-menu">ACCIONES</div>
                        <div class="link item" @click="saveAndRedirect()" v-if="!record.id && record.editing">
                            Agregar
                        </div>
                        <div class="link item" @click="saveRecord(record)" v-if="record.id && record.editing">
                            Guardar
                        </div>
                        <div class="link item" @click="cancelEditRecord()" v-if="record.editing && record.id">
                            Cancelar
                        </div>
                        <div class="link item" @click="openEditMode()" v-if="!record.editing && canOpenEditMode">
                            Modificar
                        </div>
                        <div class="link item" @click="sendSingleFolio()" v-if="record.id && !record.editing && record.active && !record.reported && !record.failed && Utils.userHasPerm('can_send_reune_complaint')">
                            Enviar folio
                        </div>
                        <div class="link item"
                            v-if="record.id && !record.editing && !record.active && Utils.userHasPerm('can_enable_reune_complaint')"
                            @click="toggleRecordActivation">
                            Habilitar
                        </div>
                        <div class="link item"
                            v-if="record.id && !record.editing && record.active && !record.reported && Utils.userHasPerm('can_disable_reune_complaint')"
                            @click="toggleRecordActivation">
                            Inhabilitar
                        </div>
                        <div class="link item" @click="resetRecordToPending()" v-if="record.id && record.failed && Utils.userHasPerm('can_reset_reune_complaint')">
                            Regresar a pendientes
                        </div>
                        <div class="link item" @click="deleteFromReune()" v-if="record.id && record.reported && Utils.userHasPerm('can_delete_reune_complaint')">
                            Eliminar de REUNE
                        </div>
                        <div class="link item" @click="showReuneErrors()" v-if="record.id && hasReuneErrors">
                            Ver errores
                        </div>
                    </div>
                </sui-grid-column>
            </sui-grid-row>
        </sui-grid>
    </section>
</template>

<script>
import Utils from '@/common/Utils'
import ComplaintService from '@/services/ComplaintService'
import SepomexService from '@/services/SepomexService'
import TaxRegime from '@/common/TaxRegime'
import ReuneRecordType from '@/common/ReuneRecordType'
import GenderAlt from '@/common/GenderAlt'
import IdentityTheft from '@/common/IdentityTheft'
import Mixins from '@/mixins/index'
import GenericService from '@/services/GenericService'

export default {
    name: 'ReuneComplaintDetails',
    components: {},
    mixins: [ Mixins ],
    data () {
        return {
            apiEndpoint: '/complaints/reune/',
            recordName: 'ReuneComplaint',
            errors: [],
            masks: { input: 'DD/MM/YYYY' },
            ReuneRecordType,
            states: [],
            locations: [],
            colonies: [],
            trimesterReported: {
                'PRIMERO': 1,
                'SEGUNDO': 2,
                'TERCERO': 3,
                'CUARTO': 4
            },
            receivingMedium: [],
            attentionLevels: [],
            TaxRegime,
            status: [],
            operations: [],
            products: [],
            subproducts: [],
            reasons: [],
            allClients: [],
            record: {
                id: null,
                folio: null,
                entityName: 'Agronegocios de Chihuahua, S.A. de C.V., SOFOM, E.N.R.',
                sector: 'Sociedades Financieras de Objeto Múltiple E.N.R.',
                dateReception: new Date(),
                dateAttended: new Date(),
                dateResolved: new Date(),
                dateNotificated: new Date(),
                dateComplaint: new Date(),
                editing: true,
                active: true,
                trimesterReported: undefined,
                sigeSystem: false
            },
            wasPendingWhenEditStarted: false
        }
    },
    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
    },
    async mounted () {
        const loader = this.$loading.show()
        try {
            await this.loadStates()
            await this.loadStatus()
            await this.loadReceivingMedia()
            await this.loadAttentionLevels()
            await this.loadResolutions()
            await this.loadClients()

            if (this.$route.params.id) {
                this.loadComplaintData()
            }

            this.record.trimesterReported = Number(this.moment().format('Q'))
        } catch (error) {
            this.$swal('Error', error.message, 'error')
        }
        loader.hide()
    },
    computed: {
        clientsOptions () {
            return Utils.displayOptionsFromArray(this.allClients, 'clientId', 'entityName')
        },
        trimesterOptions () {
            return Utils.displayOptions(this.trimesterReported)
        },
        receivingMediumOptions () {
            return Utils.displayOptionsFromArray(this.receivingMedium, 'medium_id', 'medium_description')
        },
        attentionLevelOptions () {
            return Utils.displayOptionsFromArray(this.attentionLevels, 'level_id', 'level_description')
        },
        stateOptions () {
            return Utils.displayOptionsFromArray(this.states, 'id', 'stateName')
        },
        statusOptions () {
            return Utils.displayOptionsFromArray(this.status, 'status_id', 'status_description')
        },
        resolutionOptions () {
            return Utils.displayOptionsFromArray(this.resolutions, 'resolution_id', 'resolution_description')
        },
        productOptions () {
            return Utils.displayOptionsFromArray(this.products, 'product_id', 'product_description')
        },
        subproductOptions () {
            return Utils.displayOptionsFromArray(this.subproducts, 'subproduct_id', 'subproduct_description')
        },
        reasonOptions () {
            return Utils.displayOptionsFromArray(this.reasons, 'reason_id', 'reason_description')
        },
        locationOptions () {
            return Utils.displayOptionsFromArray(this.locations, 'id', 'nombre')
        },
        colonyOptions () {
            return Utils.displayOptionsFromArray(this.colonies, 'id', 'nombre')
        },
        operationOptions () {
            return Utils.displayOptionsFromArray(this.operations, 'operation_id', 'operation_description')
        },
        reuneRecordOptions () {
            return Utils.displayOptions(this.optionsLabelsTransformation)
        },
        taxRegimeOptions () {
            return Utils.displayOptions(TaxRegime)
        },
        genderOptions () {
            return Utils.displayOptions(GenderAlt)
        },
        identityTheftOptions () {
            return Utils.displayOptions(IdentityTheft)
        },
        complaintTypeStr: function () {
            return this.record.complaintType ? Utils.displayOptionName(ReuneRecordType, this.record.complaintType) : null
        },
        trimesterReportedStr: function () {
            return this.record.trimesterReported ? Utils.displayOptionFromList(this.trimesterOptions, this.record.trimesterReported) : ''
        },
        resolutionStr: function () {
            return this.record.resolutionId ? Utils.displayOptionFromList(this.resolutionOptions, this.record.resolutionId) : '-'
        },
        penaltyTypeStr: function () {
            return this.record.penaltyId ? Utils.displayOptionFromList(this.penaltyOptions, this.record.trimesterReported) : '-'
        },
        dateReceptionStr: function () {
            return this.record.dateComplaint ? this.moment(this.record.dateComplaint).format('DD/MM/YYYY') : ''
        },
        dateAttendedStr: function () {
            return this.record.dateAttended ? this.moment(this.record.dateAttended).format('DD/MM/YYYY') : ''
        },
        dateResolvedStr: function () {
            return this.record.dateResolved ? this.moment(this.record.dateResolved).format('DD/MM/YYYY') : '-'
        },
        dateNotificatedStr: function () {
            return this.record.dateNotificated ? this.moment(this.record.dateNotificated).format('DD/MM/YYYY') : '-'
        },
        receptionMediumStr: function () {
            return this.record.receivingMediumId ? Utils.displayOptionFromList(this.receivingMediumOptions, this.record.receivingMediumId) : ''
        },
        attentionLevelStr: function () {
            return this.record.attentionLevelId ? Utils.displayOptionFromList(this.attentionLevelOptions, this.record.attentionLevelId) : ''
        },
        taxRegimeStr: function () {
            return this.record.taxRegimeId ? Utils.displayOptionFromList(this.taxRegimeOptions, this.record.taxRegimeId) : ''
        },
        genderStr: function () {
            return this.record.gender ? Utils.displayOptionFromList(this.genderOptions, this.record.gender) : ''
        },
        statusStr: function () {
            return this.record.statusId ? Utils.displayOptionFromList(this.statusOptions, this.record.statusId) : ''
        },
        operationTypeStr: function () {
            return this.record.operationId ? Utils.displayOptionFromList(this.operationOptions, this.record.operationId) : ''
        },
        productTypeStr: function () {
            return this.record.productId ? Utils.displayOptionFromList(this.productOptions, this.record.productId) : ''
        },
        subproductTypeStr: function () {
            return this.record.subproductId ? Utils.displayOptionFromList(this.subproductOptions, this.record.subproductId) : ''
        },
        reasonStr: function () {
            return this.record.reasonId ? Utils.displayOptionFromList(this.reasonOptions, this.record.reasonId) : ''
        },
        stateStr: function () {
            return this.record.stateId ? Utils.displayOptionFromList(this.stateOptions, this.record.stateId) : ''
        },
        municipalityStr: function () {
            return this.record.municipalityId ? Utils.displayOptionFromList(this.locationOptions, this.record.municipalityId) : ''
        },
        colonyStr: function () {
            return this.record.colonyId ? Utils.displayOptionFromList(this.colonyOptions, this.record.colonyId) : ''
        },
        monetaryStr: function () {
            return this.record.monetary ? 'Sí' : 'No'
        },
        foreignTransactionStr: function () {
            return this.record.foreignTransaction ? 'Sí' : 'No'
        },
        clientStr: function () {
            return this.record.clientId ? Utils.displayOptionFromList(this.clientsOptions, this.record.clientId) : ''
        },
        dateDepositedStr: function () {
            return this.record.dateDeposited ? this.moment(this.record.dateDeposited).format('DD/MM/YYYY') : '-'
        },
        optionsLabelsTransformation () {
            const newReuneRecordType = {}
            if (ReuneRecordType) {
                for (const reuneRecordTypeKey in ReuneRecordType) {
                    if (Object.hasOwnProperty.call(ReuneRecordType, reuneRecordTypeKey)) {
                        const valor = ReuneRecordType[reuneRecordTypeKey]
                        reuneRecordTypeKey === 'ACLARACION' ? newReuneRecordType['ACLARACIÓN'] = valor : newReuneRecordType[reuneRecordTypeKey] = valor
                    }
                }
            }
            return newReuneRecordType
        },
        reportedAtStr: function () {
            return this.record.reportedAt ? this.moment(this.record.reportedAt).format('DD/MM/YYYY HH:mm:ss') : '-'
        },
        hasReuneErrors: function () {
            const errors = this.record.errorsList
            return (Array.isArray(errors) && errors.length > 0) ||
                (typeof errors === 'string' && errors.trim().length > 0)
        },
        isPendingStatus () {
            return Number(this.record.statusId) === 1
        },
        isConcludedStatus () {
            return Number(this.record.statusId) === 2
        },
        canOpenEditMode () {
            if (!this.record.id) return false
            if (!this.record.reported) return true
            return this.isPendingStatus
        },
        canEditAfterReport () {
            if (!this.record.reported) return true
            if (this.isPendingStatus) return true
            return this.record.editing && this.wasPendingWhenEditStarted
        }
    },
    watch: {
        'record.editing' (isEditing) {
            if (!isEditing) {
                this.wasPendingWhenEditStarted = false
            }
        }
    },
    methods: {
        openEditMode () {
            this.wasPendingWhenEditStarted = this.record.reported && this.isPendingStatus
            this.editRecord()
        },
        async loadComplaintData () {
            await this.loadRecord(this.$route.params.id)
            await this.loadStates()
            await this.loadLocations()
            await this.loadColonies()
            await this.loadOperations()
            await this.loadProducts()
            await this.loadSubproducts()
            await this.loadReasons()
        },
        async loadClients () {
            const { data } = await GenericService.getAll('/clients', {}, { uri: `${process.env.VUE_APP_HOST}/clients/api` })
            this.allClients = data
        },
        setTrimester () {
            this.record.trimesterReported = Number(this.moment(this.record.dateComplaint).format('Q'))
        },
        sortByName (a, b, key = null) {
            const nameA = key ? a[key].toUpperCase() : a.toUpperCase()
            const nameB = key ? b[key].toUpperCase() : b.toUpperCase()
            if (nameA < nameB) return -1
            if (nameA > nameB) return 1
            return 0
        },
        async loadStates () {
            try {
                const states = await SepomexService.getStates('MEX')
                this.states = states
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadLocations () {
            try {
                if (!this.record.stateId) return
                const municipios = await SepomexService.getLocations(this.record.stateId || '', this.record.postalCode || '')
                this.locations = municipios
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadColonies () {
            try {
                if (!this.record.postalCode) return
                const colonias = await SepomexService.getColonies(this.record.postalCode || '', this.record.municipalityId || '')
                this.colonies = colonias
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadStatus () {
            try {
                this.status = await ComplaintService.getReuneStatus()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadReceivingMedia () {
            try {
                this.receivingMedium = await ComplaintService.getReuneReceptionMedium()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadAttentionLevels () {
            try {
                this.attentionLevels = await ComplaintService.getReuneAttentionLevels()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadOperations () {
            try {
                this.operations = await ComplaintService.getReuneOperations(this.record.complaintType || '')
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadProducts () {
            try {
                this.products = await ComplaintService.getReuneProducts(this.record.operationId || '')
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadSubproducts () {
            try {
                this.subproducts = await ComplaintService.getReuneSubproducts(this.record.productId || '')
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadResolutions () {
            try {
                this.resolutions = await ComplaintService.getReuneResolutions()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        async loadReasons () {
            try {
                if (!this.record.complaintType) return
                this.reasons = await ComplaintService.getReuneReasons(this.record.subproductId || '')

                if (this.record.complaintType === ReuneRecordType.CONSULTA) {
                    this.reasons = this.reasons.filter(item => item.consultation)
                }
                if (this.record.complaintType === ReuneRecordType.RECLAMACION) {
                    this.reasons = this.reasons.filter(item => item.claim)
                }
                if (this.record.complaintType === ReuneRecordType.ACLARACION) {
                    this.reasons = this.reasons.filter(item => item.clarification)
                }
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los catálogos')
            }
        },
        setLocalityId () {
            this.record.localityId = this.record.colonyId ? this.colonies.find(colony => colony.coloniaId === this.record.colonyId).tipoLocalidadId : null
        },
        toggleRecordActivation () {
            const permission = this.record.active ? 'can_disable_reune_complaint' : 'can_enable_reune_complaint'
            if (!Utils.userHasPerm(permission)) {
                this.$swal('Error', 'No tienes permiso para realizar la acción', 'error')
                return
            }
            this.record.active = !this.record.active
            this.saveRecord(this.record)
        },
        async saveAndRedirect () {
            const response = await this.saveRecord(this.record, false)
            if (!(response instanceof Error)) {
                this.$router.push({ name: this.recordName + 'List' })
            }
        },
        showReuneErrors () {
            const errors = this.record.errorsList
            let html = ''

            if (Array.isArray(errors) && errors.length) {
                html = `<ul style="text-align:left">${errors.map(error => `<li>${error}</li>`).join('')}</ul>`
            } else if (typeof errors === 'string' && errors.trim()) {
                html = `<p style="text-align:left">${errors}</p>`
            } else {
                html = '<p>No hay errores registrados para este folio.</p>'
            }

            this.$swal({
                title: 'Errores de envío REUNE',
                html,
                icon: 'warning'
            })
        },
        async resetRecordToPending () {
            if (!Utils.userHasPerm('can_reset_reune_complaint')) {
                this.$swal('Error', 'No tienes permiso para realizar la acción', 'error')
                return
            }
            const loader = this.$loading.show()
            try {
                await GenericService.create('/reune/reset', { ids: [this.record.id] })
                this.record.failed = false
                this.record.reported = false
                this.$swal('Éxito', 'El folio ha sido regresado a pendientes exitosamente', 'success')
            } catch (error) {
                const message = error.data.message || 'Ocurrió un error al regresar el folio a pendiente'
                this.$swal('Error', message, 'error')
            } finally {
                loader.hide()
            }
        },
        async deleteFromReune () {
            if (!Utils.userHasPerm('can_delete_reune_complaint')) {
                this.$swal('Error', 'No tienes permiso para realizar la acción', 'error')
                return
            }
            const loader = this.$loading.show()
            try {
                await GenericService.create('/reune/delete-folio', { id: this.record.id })
                this.$swal('Éxito', 'El folio ha sido eliminado de REUNE exitosamente', 'success')
                await this.loadRecord(this.record.id)
            } catch (error) {
                const message = error.data.message || 'Ocurrió un error al eliminar el folio de REUNE'
                this.$swal('Error', message, 'error')
            } finally {
                loader.hide()
            }
        },
        async sendSingleFolio () {
            if (!Utils.userHasPerm('can_send_reune_complaint')) {
                this.$swal('Error', 'No tienes permiso para realizar la acción', 'error')
                return
            }
            const loader = this.$loading.show()
            try {
                const response = await GenericService.create('/reune/send', { ids: [this.record.id] })
                const summary = response?.summary || {}

                if ((summary.rejected || 0) > 0) {
                    const byType = summary.byType || {}
                    const rejectedRecord =
                        (byType.consultas && byType.consultas.rejected && byType.consultas.rejected[0]) ||
                        (byType.reclamaciones && byType.reclamaciones.rejected && byType.reclamaciones.rejected[0]) ||
                        (byType.aclaraciones && byType.aclaraciones.rejected && byType.aclaraciones.rejected[0]) ||
                        null

                    const rejectedErrors = rejectedRecord?.errors
                    let errorsHtml = '<p>No se recibieron detalles de error.</p>'

                    if (Array.isArray(rejectedErrors) && rejectedErrors.length) {
                        errorsHtml = `<ul style="text-align:left">${rejectedErrors.map(error => `<li>${error}</li>`).join('')}</ul>`
                    } else if (typeof rejectedErrors === 'string' && rejectedErrors.trim()) {
                        errorsHtml = `<p style="text-align:left">${rejectedErrors}</p>`
                    }

                    this.$swal({
                        title: 'Folio rechazado',
                        html: errorsHtml,
                        icon: 'warning'
                    })
                } else {
                    this.$swal('Éxito', 'El folio se envió correctamente a REUNE', 'success')
                }

                await this.loadRecord(this.record.id)
            } catch (error) {
                const message = error?.data?.message || error?.message || 'Error al enviar el folio'
                this.$swal('Error', message, 'error')
            } finally {
                loader.hide()
            }
        }
    }
}
</script>
<style scoped>
    .header-menu {
        padding-top:5px;
        padding-bottom:5px;
        background-color: #1C1D1D;
        color: white;
        font-weight: bolder;
    }
    .item {
        margin-bottom: 5px;
    }
    .left-spaced {
        margin-left: 20px;
    }
    .accepted {
      color: green;
    }
    .rejected {
      color: red;
    }
</style>
